require("./gallery.js");

import "../../gallery/widget.scss";
